@if (show) {
    <div class="fuse-loading-bar__track">
        <mat-progress-bar [mode]="mode" [value]="progress"></mat-progress-bar>
        <span class="fuse-loading-bar__glow" aria-hidden="true"></span>
    </div>
}
